module.exports = __webpack_public_path__ + "img/output-onlinegiftools.1fb9e367.gif";